<template>
    <div class="messages-wrapper">
        <div class="messages-sidebar messages-sidebar-active" id="messagesSidebar">
            <div class="floating-menu-trigger" id="messagesSidebarTrigger" @click="triggerSidebar()">
                <i class="fad fa-bars"></i>
            </div>
            <!-- <h2> Categorii mesaje </h2> -->
            <div class="sidebar-heading-content">
<!--                <ul class="messages-categories-list" v-if="user.developer == 1">-->
<!--                    <li class="text-placeholder-radio message-placeholder-radio">-->
<!--                        <input type="radio" v-model="filteredCategory" value="lead" id="messages_category1" class="text-checkbox-input" @change="getConversations(true)">-->
<!--                        <label for="messages_category1" class="radio-input-placeholder">-->
<!--                            <span><i class="fad fa-comment-dollar"></i> Leaduri </span>-->
<!--                            <p class="new-msg-count" v-if="leadsUnreadCount>0"> {{leadsUnreadCount}} </p>-->
<!--                        </label>-->
<!--                    </li>-->
<!--                    <li class="text-placeholder-radio message-placeholder-radio">-->
<!--                        <input type="radio" v-model="filteredCategory" value="client" id="messages_category2" class="text-checkbox-input" @change="getConversations(true)">-->
<!--                        <label for="messages_category2" class="radio-input-placeholder">-->
<!--                            <span><i class="fad fa-comment-smile"></i> Clienti </span>-->
<!--                            <p class="new-msg-count" v-if="clientsUnreadCount>0"> {{clientsUnreadCount}} </p>-->
<!--                        </label>-->
<!--                    </li>-->
<!--                    <li class="text-placeholder-radio message-placeholder-radio">-->
<!--                        <input type="radio" v-model="filteredCategory" value="agent" id="messages_category3" class="text-checkbox-input" @change="getConversations(true)">-->
<!--                        <label for="messages_category3" class="radio-input-placeholder">-->
<!--                            <span><i class="fad fa-comment-dots"></i> Agenti </span>-->
<!--                            <p class="new-msg-count" v-if="agentsUnreadCount>0"> {{agentsUnreadCount}} </p>-->
<!--                        </label>-->
<!--                    </li>-->
<!--                    <li class="text-placeholder-radio message-placeholder-radio">-->
<!--                        <input type="radio" v-model="filteredCategory" value="other" id="messages_category4" class="text-checkbox-input" @change="getConversations(true)">-->
<!--                        <label for="messages_category4" class="radio-input-placeholder">-->
<!--                            <span><i class="fad fa-comment-lines"></i> Mesaje </span>-->
<!--                        </label>-->
<!--                    </li>-->
<!--                </ul>-->
                <div class="search-filter sb-heading-sector">
                    <!-- <span class="msg-sb-heading"> Cauta: </span> -->
                    <input type="search" name="q" v-model="filteredSearch" placeholder="Cauta..." @change="searchConversation()">
                    <button type="button" name="button" class="icon-btn">
                        <i class="fad fa-search"></i>
                    </button>
                </div>
                <div class="messages-project-filter sb-heading-sector">
                    <span class="msg-sb-heading"> Filtreaza dupa proiect: </span>
                    <div class="v-select-container">
                        <v-select :options="projects" v-model="filteredProject" label="name" @input="getConversations(true)">
                            <template slot="option" slot-scope="option">
                                <i class="fad fa-project-diagram"></i>
                                {{getProjectName(option)}}
                            </template>
                        </v-select>
                    </div>
                </div>
            </div>
            <div class="sidebar-conversation-wrapper">
                <ul class="conversations-list">
                    <div class="section-loading-screen" v-if="loadingLeft">
                        <div class="section-loading-bubbles">
                            <span class="d1"></span>
                            <span class="d2"></span>
                            <span class="d3"></span>
                            <span class="d4"></span>
                        </div>
                    </div>
                    <li  class="single-conversation-item" v-for="conversation in conversations" :key="conversation.id"
                        :class="{ 'single-conversation-active': selectedConversation && conversation.id === selectedConversation.id }"
                        @click="getMessagesByConversation(conversation)"
                    >
                        <div class="mock-avatar">
                            LFA
                        </div>
                        <div class="conversation-item-info">
                            <div class="conversation-receiver">
                                <span> {{getPersonForConversation(conversation.id).name}} </span>
                            </div>
                            <p class="conversation-item-data">
                                <span v-if="conversation.project"> {{conversation.project.name}} </span>
                                <span> {{dateHumanize(conversation.updated_at)}} </span>
                            </p>
                            <p class="new-msg-count" v-if="conversation.unread_messages_count > 0"> {{conversation.unread_messages_count}} </p>
                        </div>
                    </li>
                    <div class="view-more-item" v-if="conversations.length > 0 && conversations.length < conversationsCount">
                        <span class="view-more-btn" @click="getConversations()">
                            Vezi mai multe
                        </span>
                    </div>
                </ul>
            </div>
        </div>
        <div class="messages-conversation-content" id="messagesContent">
            <div class="section-loading-screen" v-if="loadingRight">
                <div class="section-loading-bubbles">
                    <span class="d1"></span>
                    <span class="d2"></span>
                    <span class="d3"></span>
                    <span class="d4"></span>
                </div>
            </div>
            <div class="clsasx" v-if="selectedConversation">
                <div class="opened-message-info">
                    <a v-if="selectedConversation.project"
                       :href="`${selectedConversation.project.url}`"
                       class="opened-message-project-link"
                       target="_blank"
                    > {{selectedConversation.project.name}} </a>
                    <div class="opened-message-sender">
                        <h2> {{getPersonForConversation(selectedConversation.id).name}} </h2>
                        <p>
                            <span v-if="getPersonForConversation(selectedConversation.id).email && selectedConversation.developer_email === this.$userEmail"> {{getPersonForConversation(selectedConversation.id).email}} </span>
                            <span v-if="getPersonForConversation(selectedConversation.id).phone && selectedConversation.developer_email === this.$userEmail"> {{getPersonForConversation(selectedConversation.id).phone}} </span>

                        </p>
                    </div>
                    <div class="element-dropdown" v-if="selectedConversation">
                        <div class="messages-floating-menu" @click="triggerConvoOptions()">
                            <i class="fad fa-cog"></i>
                        </div>
                        <ul class="actions-dropdown">
                            <li>
                                <a href="javascript:void(0)" @click="clearConversation(selectedConversation.id)" class="general-link"> Sterge conversatia </a>
                            </li>
<!--                            <li v-if="user.developer && selectedConversation.category !== 'lead'">-->
<!--                                <a href="javascript:void(0)" @click="changeCategory('lead')" class="general-link"> Muta catre leaduri </a>-->
<!--                            </li>-->
<!--                            <li v-if="user.developer && selectedConversation.category !== 'client'">-->
<!--                                <a href="javascript:void(0)" @click="changeCategory('client')" class="general-link"> Muta catre clienti </a>-->
<!--                            </li>-->
<!--                            <li v-if="user.developer && selectedConversation.category !== 'agent'">-->
<!--                                <a href="javascript:void(0)" @click="changeCategory('agent')" class="general-link"> Muta catre agenti </a>-->
<!--                            </li>-->
                        </ul>
                    </div>
                </div>
                <div class="conversation-content-messages">
                    <div v-for="(message, index) in messages" :key="index">
                        <p class="message-bubble"
                           :class="[user.email === message.receiver_email ? 'received-message': 'sent-message']"
                        >
                            <span class="bubble-timestamp"> {{dateHumanize(message.created_at)}} </span>
                            <nl2br tag="span" :text="message.body"/>
                        </p>
                    </div>
                </div>
                <div class="message-composer-box" v-if="selectedConversation.receiver">
                    <textarea v-model="messageBody" placeholder="Scrie mesaj"> </textarea>
                    <button type="button" name="button" class="icon-btn" @click="sendMessage">
                        <i class="fad fa-paper-plane"></i>
                    </button>
                </div>
            </div>
            <div v-else>
                <div class="opened-message-info">
                    <h2> Selecteaza o conversatie </h2>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import vSelect from 'vue-select'

  export default {
    name: 'Messages',
    components: {
      vSelect,
    },
    props: [
        'user','projects'
        // ,'leadsUnreadCount','clientsUnreadCount','agentsUnreadCount','conversation'
    ],
    data() {
      return {
        sidebarVal: true,
        loadingLeft: false,
        loadingRight: false,
        selectedConversation: null,
        conversationsCount: 0,
        filteredProject: null,
        // filteredCategory: null,
        filteredSearch: '',
        messageBody: '',
        conversations: [],
        messages: []
      }
    },
    mounted() {
        this.getConversations();
      // if(this.conversation) {
      //   if(this.conversation.sender_email.trim().toLowerCase() == this.user.email.trim().toLowerCase()) {
      //     this.filteredSearch = this.conversation.receiver_email;
      //   } else {
      //     this.filteredSearch = this.conversation.sender_email;
      //   }
      //   this.getConversations(true);
      //   this.selectedConversation = this.conversation;
      //   this.getMessagesByConversation(this.conversation);
      // } else {
      //   this.getConversations();
      // }
    },
    methods: {
      triggerConvoOptions () {
          $('.messages-floating-menu').siblings().toggleClass('actions_dropdown_active');
      },
      triggerSidebar() {
        this.sidebarVal = !this.sidebarVal
        // console.log(this.sidebarVal)
        let sidebarInitial = document.getElementById("messagesSidebar");
        let messagesInitial = document.getElementById("messagesContent")
        let sidebarTrigger = document.getElementById("messagesSidebarTrigger")
        if (this.sidebarVal === true) {
          sidebarInitial.classList.add("messages-sidebar-active")
          messagesInitial.classList.remove("conv-content-sidebar-closed")
          sidebarTrigger.classList.remove("floatin-trigger-inactive")
        } else {
          sidebarInitial.classList.remove("messages-sidebar-active")
          messagesInitial.classList.add("conv-content-sidebar-closed")
          sidebarTrigger.classList.add("floatin-trigger-inactive")
        }
      },
      // triggerRespSidebar(){
      //     let windowWidth = $( window ).width()
      //     let sidebarTrigger = document.getElementById("messagesSidebarTrigger")
      //     let sidebarInitial = document.getElementById("messagesSidebar");
      //     if(windowWidth < 880){
      //         this.sidebarVal = false
      //         sidebarInitial.classList.remove("messages-sidebar-active")
      //         sidebarTrigger.classList.remove("floatin-trigger-inactive")
      //     }
      // },
      searchConversation() {
        if (this.filteredSearch.length > 2) {
          this.getConversations(true)
        } else if (this.filteredSearch.length == 0) {
          this.getConversations(true)
        }
      },
      getConversations(emptyFirst = false) {
        this.loadingLeft = true;
        let vm = this
        if (emptyFirst) {
          this.conversations = [];
        }
        let skip = this.conversations.length;
        window.axios.get('/ajax/conversations', {
          params: {
            skip: skip,
            project: (this.filteredProject) ? this.filteredProject.id : null,
            // category: (this.filteredCategory) ? this.filteredCategory : null,
            q: (this.filteredSearch && this.filteredSearch.length > 2) ? this.filteredSearch : null,
          }
        })
          .then(function (response) {
            vm.conversations = vm.conversations.concat(response.data.data.conversations);
            vm.conversationsCount = response.data.data.total_rows;
            vm.loadingLeft = false;
          })
          .catch(function () {
          });
      },
      getPersonForConversation(conversationId) {
        // console.log(conversationId);
        let conversation = this.conversations.find(element => element.id === parseInt(conversationId));
        let output = [];
        output.email = '';
        output.name = '';
        output.phone = '';
        if (conversation) {
          if(conversation.developer_email === this.$userEmail) {
            if (conversation.sender_email === this.$userEmail) {
              output.email = conversation.receiver_email;
              output.name = conversation.receiver_name || 'Fara Cont';
              output.phone = conversation.receiver_phone;
              return output
            } else {
              output.email = conversation.sender_email;
              output.name = conversation.sender_name || 'Fara Cont';
              output.phone = conversation.sender_phone;
              return output
            }
          } else {
            if (conversation.sender_email === this.$userEmail) {
              output.email = conversation.receiver_email;
              output.name = 'Proiect rezidențial';
              output.phone = '';
              return output
            } else {
              output.email = conversation.sender_email;
              output.name = 'Proiect rezidențial';
              output.phone = '';
              return output
            }
          }
        }
        return output
      },
      getMessagesByConversation(conversation) {
        let vm = this
        let windowWidth = $( window ).width()
        if(windowWidth < 880){
            this.triggerSidebar()
        }
        this.messages = [];
        this.loadingRight = true;
        this.selectedConversation = conversation;
        // conversation.unread_messages_count = 0;
        window.axios.get(`/ajax/conversations/${conversation.id}/messages`)
          .then(function (response) {
            vm.messages = response.data.data;
            vm.loadingRight = false;
          })
          .catch(function () {
            vm.loadingRight = false;
            window.Swal.fire({
              html: 'Oops... Ceva a mers prost. Va rugam sa incercati din nou mai tarziu.',
              icon: 'error'
            })
          });
      },
      sendMessage() {
        if (this.messageBody.length > 0) {
          this.loadingRight = true;
          let vm = this
          window.axios.post('/ajax/conversations', {
            body: this.messageBody,
            project: (this.selectedConversation.project) ? this.selectedConversation.project.id : null,
            receiver: this.getPersonForConversation(this.selectedConversation.id).email
          })
            .then(function (response) {
              vm.loadingRight = false;
              vm.messageBody = '';
              vm.messages.push(response.data.data)
            })
            .catch(function () {
              vm.loadingRight = false;
              vm.buttonDisable = false;
              window.Swal.fire({
                html: 'Oops... Ceva a mers prost. Va rugam sa incercati din nou mai tarziu.',
                icon: 'error'
              })
            });
        }
      },
      getProjectName(project) {
        let name = project.name+', '+project.county.name+', '+project.city.name;
        if (project.zone) {
          name += ', '+project.zone.name;
        }
        if (project.subzone) {
          name += ', '+project.subzone.name;
        }
        return name;
      },
      clearConversation(conversationId) {
        window.Swal.fire({
          title: 'Esti sigur?',
          text: "Aceste mesaje nu vor mai putea fi recuperate!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Da, sterge!',
          cancelButtonText: 'Nu, anuleaza'
        }).then((result) => {
          if (result.value) {
            window.axios.delete(`/ajax/conversations/${conversationId}/clear`)
              .then(function () {
                window.Swal.fire({
                  html: 'Conversatia a fost stearsa cu succes',
                  icon: 'success',
                  timer: 2000,
                  showCancelButton: false,
                  showConfirmButton: false
                }).then(() => {
                  window.location.reload();
                })

              })
              .catch(function () {
                window.Swal.fire({
                  html: 'Oops... Ceva a mers prost. Va rugam sa incercati din nou mai tarziu.',
                  icon: 'error'
                })
              });
          }
        })
      }
      // ,changeCategory(category) {
      //   let vm = this
      //   if (category) {
      //     window.axios.post(`/ajax/conversations/${this.selectedConversation.id}/change-category`, {
      //       category: category
      //     })
      //       .then(function () {
      //         let conversation = vm.conversations.find(element => element.id === parseInt(vm.selectedConversation.id));
      //         if (conversation) {
      //           conversation.category = category
      //         }
      //         window.Swal.fire({
      //           html: 'Conversatia a fost mutata cu succes',
      //           icon: 'success',
      //           timer: 2000,
      //           showCancelButton: false,
      //           showConfirmButton: false
      //         })
      //       })
      //       .catch(function () {
      //         window.Swal.fire({
      //           html: 'Oops... Ceva a mers prost. Va rugam sa incercati din nou mai tarziu.',
      //           icon: 'error'
      //         })
      //       });
      //   }
      // }
    }
  }
</script>

<style lang="css" scoped>
</style>
